module.exports = __webpack_public_path__ + "static/media/rewards_card_bg_pic.5ce5698e.png";